import Rules from "../rules.js";
import Utils from "../utils.js";

class PresFactsBox {
  constructor() {}
  setup() {
    window.FactBox = (group, country, hasResidency) => (
      `<div class="admission-box admission-facts">
        <h2>${i18n.titleFacts}</h2>
        ${App.program["studiet-master-spesielle-fakta"] ? App.program["studiet-master-spesielle-fakta"] : ""}
        ${FactsDates(group, country, hasResidency, App.date.length > 1)}
      </div>`
    )

    window.FactsDates = function(group, country, hasResidency, isMultipleDates) {
      var html = ``;
      for(var i = 0; i < App.date.length; i++) {
        html += `${FactsDate(App.date[i], group, country, hasResidency, isMultipleDates)}`;
      }
      return html;
    }

    window.FactsDate = (date, group, country, hasResidency, isMultipleDates) => (
      (isMultipleDates ? `<h3>${i18n.titleProgrammeStarts} ${Utils.formatMonth(date["start"])}</h3>` : ``) +
      `<ul>
        ${FactBoxLiDate(date, i18n.lblApplicationPortalOpen, "portal-opens")}
        ${FactBoxLiDate(date, i18n.lblApplicationDeadline, "deadline")}
        ${FactBoxLiDate(date, i18n.lblApplyEarlyReply, "early-answer-deadline", i18n.applyEarlyReplyExtra)}
        ${FactBoxLi(i18n.lblAvailablePlaces, App.program.availablePlaces)}` +
        (isMultipleDates ? `` : `${FactBoxLiMonth(date, i18n.lblProgrammeStarts, "start")}`) +
        (App.program["studiet-master-pris-fri"] ? ToParagraphFactBoxLi(i18n.lblProgrammePrice, PriceSpecialRule(HeaderDowngrade(App.program["studiet-master-pris-fri"]), group)) : "") +
        (Rules.showSpecialTuitionRule(group, country, hasResidency) ? "<li>" + i18n.factsTuitionFees + "</li>" : "") +
      `</ul>`
    )

    window.PriceSpecialRule = function(price, group) {
      var priceLines = $(price).text().split("\n");
      var priceLinesResult = "";
      priceLines.forEach((priceLine) => {
        priceLine = $.trim(priceLine);
        if(/^###IF\-GROUP/.test(priceLine)) {
          var regexMatch = new RegExp("^###IF-GROUP-" + group + "###");
          var regexNotMatchCondition = new RegExp("^###IF-GROUP-NOT-");
          var regexNotMatch = new RegExp("^###IF-GROUP-NOT-" + group + "###");
          if(regexMatch.test(priceLine) || (regexNotMatchCondition.test(priceLine) && !regexNotMatch.test(priceLine))) {
            priceLinesResult += "<p>" + priceLine.replace(/^###IF\-GROUP\-[^#]+###/, "") + "</p>";
          }
        } else if(priceLine != "") {
          priceLinesResult += "<p>" + priceLine + "</p>";
        }
      });
      return priceLinesResult;
    }

    window.ToParagraphFactBoxLi = (lbl, text) => (
      ((text != null && $(text).filter("p").length > 1) ? `<li>${lbl}: ${text}</li>` : FactBoxLi(lbl, text.replace(/<[^>]*>/igm, "")))
    )

    window.FactBoxLi = (lbl, text) => (
      text != null ? `<li>${Label(lbl, text)}</li>` : ``
    )
    window.FactBoxLiMonth = (date, lbl, id, extra) => (
      date[id] ? `<li>${Label(lbl, Utils.formatMonth(date[id]) + (typeof extra != "undefined" ? extra : ""))}</li>` : ``
    )
    window.FactBoxLiDate = (date, lbl, id, extra) => (
      date[id] ? `<li>${Label(lbl, Utils.formatDate(date[id]) + (typeof extra != "undefined" ? extra : ""))}</li>` : ``
    )
  }
}
export default new PresFactsBox;